
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patents",
      function () {
        return require("private-next-pages/patents.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patents"])
      });
    }
  